<template>
    <div>
            <div style="padding:0 10px;">

                <div style="text-align: right;">
                 <el-button @click="uploadFiles()" v-if="uploadType === '0'" style="color: #FFF; background: #409EFF;">Upload File</el-button>
            </div>
                <ul class="files-content">
                    <li v-for="item in files" :key="item.ID" style="padding:10px 0;">
                        <div style="display:inline-block;width:calc(100% - 100px);">
                            <i class="el-icon-document"></i>
                            <label style="top: 4px;" class="files" @click="toggle(item)" title="Download">{{ item.Name }}</label>
                        </div>
                        <el-button @click="deleteFile(item)" size="small" type="danger" style="vertical-align: top;margin-left:15px;" icon="el-icon-delete" circle></el-button>
                    </li>
                <Pagination :total="total" @serch="changePage"></Pagination>
                <div style="height:30px;"></div>
                </ul>

            </div>
              <Upload v-if="uploadBlock" @close="closeUploadFiles()" @success="getFiles()"></Upload>
        <iframe id="ifile" name="ifile" :src="iframeUrl" style="display:none"></iframe>
       
    </div>
</template>
<script>
import Pagination from '@/components/common/Pagination';
import Upload from "@/components/Solutions/Upload.vue";
export default {
    props:{
    },
    components:{
        Upload,
        Pagination
    },
    data () {
        return {
            data:{},
            files:[],
            macBlock:false,
            grade:"0",
            uploadBlock:false,
            lastReviewBlock:false,
            iframeUrl:"",
            uploadType:"0",
            aaa:false,
            statusBlock:false,
            total:0,
            row:10,
            pagenumber:1
        };
    },
    mounted () {
        this.getFiles ();
    },
    methods:{
        goProductVersionInfo () {
            this.drawer = true;
            this.grade = "1";
            this.uploadType = "1";
            this.getFiles ();
        },
        getUploadProductVesionInfo () {
            this.drawer = true;
            this.grade = "0";
            this.uploadType = "1";
            this.getFiles ();
        },
        getReviewProductVesionInfo () {
            this.drawer = true;
            this.grade = "2";
            this.uploadType = "1";
            this.getFiles ();
        },
        closeUploadFiles() {
            this.uploadBlock = false;
            this.getFiles ();
        },
        uploadProductVesionInfo () {
            this.uploadBlock = true;
            this.uploadType = "1";
            this.getFiles ();
        },
        uploadFiles () {
            this.uploadBlock = true;
            this.uploadType = "0";
            this.getFiles ();
        },
        // 页数条数更改
        changePage (row,pagenumber) {
            this.row = row;
            this.pagenumber = pagenumber;
            this.getFiles();
        } ,
        getFiles () {
            this.files = [];
            this.$http.get("getFileSolutions",{
                row:this.row,
                page:this.pagenumber
            },(data)=>{
                this.files = data.data;
                this.total = Number(data.total);
            });
        },
        deleteFile (val) {
            this.$baseNotice.messageBox("confirm",`Are you sure you want to delete the file : ${val.Name}?`,"warning","warning")(()=>{
                this.$http.delete("deleteFileSolutions",{
                    ID:val.ID,
                    Type:this.uploadType
                },(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.getFiles();
                });
            });
        },
        toggle (data) {
            this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/marketingMaterials/${data.Name}`;
        }
    }
};
</script>
<style lang="less" scoped>
    .item-content{
        padding: 10px 50px;
        .item-title{
            display: inline-block;
            width: 200px;
            color: black;
        }
        label{
            color: #7b7b7b;
        }
        .link{
            color: #03a9f4;
            cursor:pointer;
        }
    }
    .files-content{
        padding: 40px 0;
        list-style: none;
        .files{
            text-decoration:underline;
            cursor: pointer;
            &:hover{
                color:#03a9f4;
            }
        }

    }
    .text-label{
        display: inline-block;
        width: 50px;
        text-align: right;
    }
</style>
